 const noWhiteSpace=(e)=>{
        if (e.key === " " && e.target.value.length===0) {
                e.preventDefault();
              }
}
export default noWhiteSpace